import classnames from 'classnames';

import { CustomCursor } from 'components/custom-cursor/CustomCursor';
import { H3 } from 'components/heading/Heading';
import { Link } from 'components/link/Link';
import { IconChevron } from 'components/icon/Icon';

import s from './PartyFactCard.module.scss';
import { useIntl } from 'react-intl';
import {
  LightningIconHover,
  LightningIconMedium,
  LightningIconPress,
} from 'components/new-buttons/LightningIcon';

const c = classnames.bind(s);

type Props = {
  text: string;
  title: string;
  link?: string;
};

export const PartyFactCard = ({ text, title, link }: Props) => {
  const { formatMessage } = useIntl();
  if (!title || !link || !text) {
    return null;
  }

  return (
    <Link className={c(s.wrapper)} to={link}>
      <CustomCursor
        className={s.customCursor}
        clickingClassName={s.clickingClassName}
      >
        {formatMessage({
          id: 'view_profile',
          defaultMessage: 'Skoða',
        })}
        <IconChevron />
      </CustomCursor>
      <div className={s.content}>
        <div className={s.lightningWrapper}>
          <div className={s.lightningIconWrapper}>
            <LightningIconMedium className={s.lightning} />
            <LightningIconHover className={s.lightningHover} />
            <LightningIconPress className={s.lightningPress} />
          </div>
          <div className={s.line}></div>
        </div>
        <div className={s.overlay}></div>
        <div className={s.overlayHover}></div>
        <div className={s.overlayPress}></div>
        <div className={s.info}>
          <H3 className={s.infoName} skipGradient>
            {text}
          </H3>
          <H3 className={s.infoSubtitle} skipGradient>
            {title}
          </H3>
        </div>
      </div>
    </Link>
  );
};
